import { useContext } from 'react';

import { CategoricalBarChartLoading } from '../contexts/CategoricalBarChartLoading.js';

export const useCategoricalBarChartLoading = () =>
  useContext(CategoricalBarChartLoading);
